import { observer } from 'mobx-react-lite';
import React from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';

import { useStore } from '../../../../../utils/hooks';
import { BusinessSetupPanel } from '../../../../presentational';
import { useBusiness } from '../../../../providers/Business';

const Redirector = () => {
	const store = useStore();
	const { path } = useRouteMatch();
	const { business } = useBusiness();

	const { data, isFetched } = business;

	if (!store.isClient) return <Redirect to={`${path}/account`} />;

	if (isFetched && !data?.isConfigured) return <BusinessSetupPanel />;

	return <Redirect to={`${path}/business-profile`} />;
};
Redirector.displayName = 'Settings.Redirector';

export default observer(Redirector);
